import { createBrowserRouter } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { ChatPage } from "./pages/ChatPage";
import { LoginPage } from "./features/auth/LoginPage";
import { ProtectedRoute } from "./features/auth/ProtectedRoute";
import { AgentCataloguePage } from "./features/agents/AgentCataloguePage";
import { AgentDetailPage } from "./features/agents/AgentDetailPage";
import { SkillDetailPage } from "./features/skills/SkillDetailPage";
import { SkillStorePage } from "./features/skills/SkillStorePage";
import { ValidatorInboxPage } from "./features/access/ValidatorInboxPage";
import { AdminUsersPage } from "./features/admin/AdminUsersPage";
import { AdminUserDetailPage } from "./features/admin/AdminUserDetailPage";
import { AdminGroupsPage } from "./features/admin/AdminGroupsPage";
import { AdminGroupDetailPage } from "./features/admin/AdminGroupDetailPage";
import { AdminAgentsPage } from "./features/admin/AdminAgentsPage";
import { AdminAgentDetailPage } from "./features/admin/AdminAgentDetailPage";
import { AdminAgentFormPage } from "./features/admin/AdminAgentFormPage";
import { AdminSkillsPage } from "./features/admin/AdminSkillsPage";
import { AdminSkillDetailPage } from "./features/admin/AdminSkillDetailPage";
import { AdminSkillFormPage } from "./features/admin/AdminSkillFormPage";
import {
  AdminSkillCategoriesPage,
  AdminUseCasesPage,
} from "./features/admin/AdminReferentialPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <HomePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/agents",
    element: (
      <ProtectedRoute>
        <AgentCataloguePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/agents/:slug",
    element: (
      <ProtectedRoute>
        <AgentDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/chat",
    element: (
      <ProtectedRoute>
        <ChatPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/chat/:sessionId",
    element: (
      <ProtectedRoute>
        <ChatPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/skills",
    element: (
      <ProtectedRoute>
        <SkillStorePage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/skills/:slug",
    element: (
      <ProtectedRoute>
        <SkillDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/access-requests",
    element: (
      <ProtectedRoute>
        <ValidatorInboxPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/users",
    element: (
      <ProtectedRoute>
        <AdminUsersPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/users/:userId",
    element: (
      <ProtectedRoute>
        <AdminUserDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/groups",
    element: (
      <ProtectedRoute>
        <AdminGroupsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/groups/:name",
    element: (
      <ProtectedRoute>
        <AdminGroupDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/agents",
    element: (
      <ProtectedRoute>
        <AdminAgentsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/agents/new",
    element: (
      <ProtectedRoute>
        <AdminAgentFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/agents/:slug",
    element: (
      <ProtectedRoute>
        <AdminAgentDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/agents/:slug/edit",
    element: (
      <ProtectedRoute>
        <AdminAgentFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/skills",
    element: (
      <ProtectedRoute>
        <AdminSkillsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/skills/new",
    element: (
      <ProtectedRoute>
        <AdminSkillFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/skills/:slug",
    element: (
      <ProtectedRoute>
        <AdminSkillDetailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/skills/:slug/edit",
    element: (
      <ProtectedRoute>
        <AdminSkillFormPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/skill-categories",
    element: (
      <ProtectedRoute>
        <AdminSkillCategoriesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/admin/use-cases",
    element: (
      <ProtectedRoute>
        <AdminUseCasesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/login/callback",
    element: <LoginPage />,
  },
]);
